<template>
  <div v-if="visible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white w-full max-w-xl p-6 sm:p-8 rounded-lg shadow-lg overflow-y-auto max-h-[90vh]">
      <h2 class="text-xl sm:text-2xl font-semibold mb-4 text-gray-800 text-center sm:text-left">
        {{ roleTitle }} Terms and Conditions
      </h2>

      <div class="space-y-4 mb-6">
        <div v-for="term in terms" :key="term.id" class="border border-gray-200 rounded-md p-4">
          <h3 class="font-medium text-gray-900">{{ term.title }}</h3>
          <p class="text-sm text-gray-600 mt-1 text-justify whitespace-pre-wrap">
            {{ term.description }}
          </p>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row justify-center sm:justify-end gap-3">
        <button 
          @click="$emit('cancel')" 
          class="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 w-full sm:w-auto"
        >
          Cancel
        </button>
        <button 
          @click="acceptTerms" 
          class="px-4 py-2 bg-[#4d148c] text-white rounded hover:bg-[#3a0e6e] w-full sm:w-auto"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
  visible: Boolean,
  role: {
    type: String,
    default: 'sender' // or 'deliverer'
  },
  terms: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(['accept', 'cancel']);


const acceptTerms = () => {
  emit('accept');
};

const roleTitle = computed(() =>
  props.role === 'sender' ? 'Sender' : 'Deliverer'
);
</script>